<template>
<nav style="z-index:4;padding-left:40px !important;padding-right:40px !important;" class="navbar navbar-expand-lg navbar-light bg-light px-0 nav-menu menu-color"  >

 <button class="navbar-toggler " type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>



<a :href="'/Inicio'"><img style="width:100px" :src="enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos+'/PJ/Logotipo_Negativo_Vertical.png'" /></a>
<div class="collapse navbar-collapse" id="navbarSupportedContent">

<ul v-for="menu in Menus" :key="menu.index" class="menu-root navbar-nav">
<li class="item-menu root nav-item active" >
  <router-link  v-if="!menu.ConSubmenus && menu.EsDescarga==false &&  !menu.RutaParaAccesar.includes('http')" :to="menu.RutaParaAccesar" class="nav-link item-menu" >
              {{menu.Titulo}}
  </router-link> 
  <a  v-if="!menu.ConSubmenus && menu.EsDescarga==false && menu.RutaParaAccesar.includes('http')" :href="menu.RutaParaAccesar" class="nav-link item-menu" target="_blank">
              {{menu.Titulo}}
  </a> 
  <a v-else-if="menu.EsDescarga==true && !menu.ConSubmenus && !menu.AbrirEnVisor" target="_blank" :href="DescargarArchivo(menu.RutaParaAccesar)" class="nav-link"  >
    <!-- v-else-if="menu.Submenus.length <=0 && menu.EsDescarga==true"-->
              {{menu.Titulo}}
  </a>
   <a v-else-if="menu.EsDescarga==true && !menu.ConSubmenus && menu.AbrirEnVisor" target="_blank" @click="AbreElVisor(menu.RutaParaAccesar)" class="nav-link"  >
              {{menu.Titulo}}
  </a>
<!-- <a v-else v-on:click="menu.Mostrar=!menu.Mostrar" class="nav-link"  >
               {{menu.Titulo}}
  </a> -->
  <div v-else-if="menu.ConSubmenus" @mouseleave="menu.Mostrar = false">
  <a   data-toggle="dropdown" v-bind:class="{'dropdown-toggle':menu.ConSubmenus}" class="nav-link"  v-on:click="menu.Mostrar=!menu.Mostrar">
              {{menu.Titulo}}
  </a> 
  <ul v-if="menu.Mostrar" class="ul contenedor-submenus"  @mouseleave="menu.Mostrar = false" >
     <Submenu v-for="submenu in menu.Submenus" :key="submenu.index"  v-bind:folder="submenu"></Submenu>
  </ul>
</div>

</li>

</ul>

</div>
</nav>



</template>

<script>
  import axios from 'axios'
  import api from '@/../static/js/api'
  import Submenu from '@/components/Micrositios/Comun/MenuMicrositio/SubmenuMicrositio.vue'
  import enumeraciones from "@/../static/js/enumeraciones";
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

    export default {
    data() {
        return {
          
        Menus: [],
        Submenus:[],  
        presidencia: false,
        consejodelajudicatura: false,
        supremotribunal: false,
        salaadministrativa: false,
        mostrar:false,
        enumeraciones,
        enSubmenu:false,
        enumeraciones_sicpo

      }
    },
    components:{
      Submenu
    },
    methods: {

      AbreElVisor: function(vinculo) {  
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },

      contraerMenu(elemento){
var auxMenu = this.Menus;
       
       this.Menus.forEach(function callback(ele,index,array){
          if(ele.MenuId != elemento.MenuId){
              auxMenu[index].Mostrar = false
            
          }else{
            auxMenu[index].Mostrar = !auxMenu[index].Mostrar
             
          }
       }
       
       );
         
      },

      VarificaSubmenus(menu) {
        
        var conSubmenu = false
        if (menu.Submenus != "") {
          conSubmenu =true
        }
        return conSubmenu;
      },

      async CargaMenu() {
       // console.log("ruta carga "+api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial);
        var paginaRoute = this.$store.getters.Get_SICPO_Micrositio_MenuRuta;
        
        let peticion = {
          Url: paginaRoute,
          conSubmenus:true,
          tipoPosicion:1,
          conSoloSubmenusActivos:true,
          EsPrueba: enumeraciones.EsPrueba
        }
        axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ObtenLosMenusYSubmenusDeMicrositio, peticion).then(async response => {
          this.Menus = response.data.MenuMicrositio.menus;
        }).catch(e => {
          console.log('Error de Pagina: ' + e)
        }); 
      },
      IdentificadorMenu(idSubmenu) {      
        this.$store.dispatch("A_SICPO_Micrositio_IdSubmenu", idSubmenu); 
      },

    DescargarArchivo: function(vinculo) {
  var ejecucion=null;

  if(vinculo != null){

    ejecucion =api.conexion+api.Comun.funcion.DescargarArchivo+'?'+'rutaDelArchivo='+vinculo;
  }
 return ejecucion;
 },
      
    },
    mounted() {
      
      this.CargaMenu()

    },
    computed: {
      MenuMicrositio() {
        
        return true

      }
    },
 
  }
</script>

<style scoped>
.menu-color{
  background-color:  rgb(126,127,116) !important;
}

.texto-blanco{
  color: black;
}

.nav-link{
color: rgb(250, 249, 249) !important;
font-size: 1.2rem !important;
text-align: center;

}

.nav-link:hover{
  color: rgb(34,34,34) !important;
}

 

.contenedor-submenus{
  
  background-color: rgb(0,117,115);
  /* border: chartreuse; */
  display: block;
  padding: 0;
  position: absolute;
  color: white;
  text-align: justify;
}

.collapse{
  justify-content: center;
}


@media only screen and (max-width:991px){
.contenedor-submenus{
  
  /* background-color: red;
  border: chartreuse; */
  display: inline;
  padding: 0;
  position: relative;
  
}

.nav-link{
  text-align: left;
}


.boton{
background-color: burlywood !important;
}

}


</style>




// WEBPACK FOOTER //
// src/components/Micrositios/Comun/MenuMicrositio/MenuMicrositio.vue